var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9993 6.66675C21.5993 6.66675 6.66602 21.6001 6.66602 40.0001C6.66602 58.4001 21.5993 73.3334 39.9993 73.3334C58.3993 73.3334 73.3327 58.4001 73.3327 40.0001C73.3327 21.6001 58.3993 6.66675 39.9993 6.66675ZM33.3327 55.0001V25.0001L53.3327 40.0001L33.3327 55.0001Z",
    fill: "#B79C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/play_icon.8b0684e776145e9c9683e2031663419a.svg";
export { ForwardRef as ReactComponent };